import React, { useState, useEffect } from "react";
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import LocationsAutocomplete from "./LocationsAutocomplete";
import CategoryMultiSelect from "./CategoryMultiSelect";
import MultiRangePriceSlider from "./MultiRangePriceSlider/MultiRangePriceSlider";
import { useGetOptionCurrenciesQuery } from '../../../features/details/detailsApiSlice';

const FiltersSidebar = ({
    payment,
    setPayment,
    currencyId,
    setCurrencyId,
    paymentBounds,
    categories,
    setCategories,
    categoryCounts,
    setCenter,
    locationFilter,
    setLocationFilter,
    sort,
    setSort,
    isMapApiLoaded
}) => {
    const { t } = useTranslation();
    const { data: currencies = [] } = useGetOptionCurrenciesQuery();

    const handleCurrencyChange = event => {
        const nextCurrencyId = event.target.value ? Number(event.target.value) : null;
        setCurrencyId(nextCurrencyId);
        setPayment(null);
    };

    const hasPaymentBounds = paymentBounds?.currencyId === currencyId
        && Number.isFinite(paymentBounds?.min)
        && Number.isFinite(paymentBounds?.max);

    useEffect(() => {
        // Sliding Sidebar 
        $('.enable-filters-button').off('click.help2fixFilters').on('click.help2fixFilters', function () {
			$('.full-page-sidebar').toggleClass("enabled-sidebar");
			$(this).toggleClass("active");
			$('.filter-button-tooltip').removeClass('tooltip-visible');
		});

		/*  Enable Filters Button Tooltip */
        $(window).off('load.help2fixFilters').on('load.help2fixFilters', function () {
			$('.filter-button-tooltip').css({
				left: $('.enable-filters-button').outerWidth() + 48
			}).addClass('tooltip-visible');
        });

        return () => {
            $('.enable-filters-button').off('click.help2fixFilters');
            $(window).off('load.help2fixFilters');
        };
    }, []);

    return <div className="full-page-sidebar hidden-sidebar">
    <div className="full-page-sidebar-inner">{/*data-simplebar*/}

        <div className="sidebar-container">

            <div className="sidebar-widget">
                <h3>{t('Location')}</h3>
                <LocationsAutocomplete
                    setCenter={setCenter}
                    initialLocation={locationFilter}
                    onLocationChange={setLocationFilter}
                    isMapApiLoaded={isMapApiLoaded} />
            </div>
            
            <div className="sidebar-widget">
                <h3>{t('Category')}</h3>
                <CategoryMultiSelect
                    selectedCategories={categories}
                    setCategories={setCategories}
                    categoryCounts={categoryCounts} />
            </div>

            <div className="sidebar-widget">
                <h3>{t('SortBy')}</h3>
                <select value={sort} onChange={event => setSort(event.target.value)}>
                    <option value="newest">{t('NewestFirst')}</option>
                    <option value="oldest">{t('OldestFirst')}</option>
                    <option value="payment">{t('HighestPayment')}</option>
                </select>
            </div>
            
            <div className="sidebar-widget">
                <h3>{t('Payment')}</h3>
                <select value={currencyId || ''} onChange={handleCurrencyChange}>
                    <option value="">{t('AllCurrencies')}</option>
                    {currencies.map(currency => <option key={currency.id} value={currency.id}>
                        {currency.currency}
                    </option>)}
                </select>

                {currencyId && hasPaymentBounds && <>
                    <div className="margin-top-55"></div>
                    <MultiRangePriceSlider
                        key={`${currencyId}-${paymentBounds.min}-${paymentBounds.max}`}
                        payment={payment}
                        setPayment={setPayment}
                        min={paymentBounds.min}
                        max={paymentBounds.max} />
                </>}

                {currencyId && !hasPaymentBounds && <p style={{ marginTop: 12 }}>{t('NoOpenJobsForCurrency')}</p>}
                {!currencyId && <p style={{ marginTop: 12 }}>{t('SelectCurrencyToFilterPayment')}</p>}
            </div>

        </div>
        {/* <!-- Sidebar Container / End --> */}

        {/* <div className="sidebar-search-button-container">
            <button className="button ripple-effect">Search</button>
        </div> */}

    </div>
</div>;
};

export default FiltersSidebar;
